export default "__VITE_ASSET__1b8cc0b4__"